import { EnumEstatusConsulta, EnumTipoBusquedaFolio } from "../settings/enumConfig";
import {
    apiCallCenterCancelarFolioEspecialistaConsulta,
    apiCallCenterGetConsultaDetalle,
    apiCallCenterGetFolioUsuairo,
    apiCallCenterSaveFolioEspecialistaConsulta,
    apiFolioGetReport,
    apiGetColaboradoresCallCenterEspecialistas,
} from "../settings/apiConfig";
import { blue, green, red, yellow } from "@material-ui/core/colors";
import { createContext, useContext, useState } from "react";
import { fnHandleChangeChek, fnHandleChangeDate, fnHandleChangeText } from "../settings/handleConfig";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import { getFormConsulta, getFormFiltroConsulta, getModelConsulta } from "../models/AdminConsultaModel";

import BlockIcon from "@material-ui/icons/Block";
import DoneIcon from "@material-ui/icons/Done";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import TimerIcon from "@material-ui/icons/Timer";
import UpdateIcon from "@material-ui/icons/Update";
import { rxCorreo } from "../settings/regexConfig";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const AdminConsultaContext = createContext();

export function AdminConsultaProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, Post } = useRequest();

    const [usuarioColaborador, setUsuarioColaborador] = useState(null);
    const [listaConsultas, setListaConsultas] = useState([]);
    const [consultaSeleccionada, setConsultaSeleccionada] = useState(getModelConsulta());

    const [modalOpenFormConsulta, setModalOpenFormConsulta] = useState(false);
    const [modalOpenCancelarConsulta, setModalOpenCancelarConsulta] = useState(false);

    const [formConsulta, setFormConsulta] = useState(getFormConsulta());
    const [formFiltroConsulta, setFormFiltroConsulta] = useState(getFormFiltroConsulta());
    const [folioValidado, setFolioValidado] = useState(false);
    const [folioUsuarioEncontrado, setFolioUsuarioEncontrado] = useState(null);

    const handleOpenFormConsulta = (value) => {
        setModalOpenFormConsulta(value);
    };

    const handleOpenCancelarConsultar = (value) => {
        setModalOpenCancelarConsulta(value);
    };

    const handleChangeConsultaSeleccionada = (value) => {
        setConsultaSeleccionada(value);
    };

    const handleChangeFolioValidado = (value) => {
        setFolioValidado(value);
        if (!value) {
            setFolioUsuarioEncontrado(null);
        }
    };

    const handleChangeFormConsultaText = fnHandleChangeText(formConsulta, setFormConsulta);
    const handleChangeFormConsultaCheck = fnHandleChangeChek(formConsulta, setFormConsulta);
    const handleChangeFormConsultaDate = (dateFin) => {
        const { txtFechaProgramadaFin } = formConsulta;
        setFormConsulta({
            ...formConsulta,
            txtFechaProgramadaFin: { ...txtFechaProgramadaFin, value: dateFin, error: !dateFin },
        });
    };
    const handleChangeFormConsultaDateInicio = (dateInicio) => {
        const { txtFechaProgramadaInicio, txtFechaProgramadaFin } = formConsulta;
        //console.log(dateInicio);
        const dateFin = new Date(dateInicio.getTime());
        dateFin.setHours(dateFin.getHours() + 1);
        setFormConsulta({
            ...formConsulta,
            txtFechaProgramadaInicio: { ...txtFechaProgramadaInicio, value: dateInicio, error: !dateInicio },
            txtFechaProgramadaFin: { ...txtFechaProgramadaFin, value: dateFin, error: !dateFin },
        });
    };
    const handleChangeFormFiltroConsultaDate = fnHandleChangeDate(formFiltroConsulta, setFormFiltroConsulta);
    const handleChangeFormFiltroConsultaDateDe = (date) => {
        const { txtFechaDe, txtFechaA } = formFiltroConsulta;
        setFormFiltroConsulta({
            ...formFiltroConsulta,
            txtFechaDe: { ...txtFechaDe, value: date },
            txtFechaA: { ...txtFechaA, value: date },
        });
    };

    const handleClickNuevaConsulta = () => {
        const consulta = getModelConsulta();
        setFolioUsuarioEncontrado(null);
        setFolioValidado(false);
        fnFillFormConsulta(consulta);
        setConsultaSeleccionada(consulta);
        setModalOpenFormConsulta(true);
    };

    const handleClickEditarConsulta = () => {
        if (consultaSeleccionada.iIdConsulta === 0) {
            handleOpenAlert("Seleccione una consulta de la tabla para continuar", "warning");
            return;
        }
        if (consultaSeleccionada.iIdEstatusConsulta === EnumEstatusConsulta.Cancelado) {
            handleOpenAlert("Las consultas canceladas no se pueden reprogramar", "warning");
            return;
        }
        if (consultaSeleccionada.iIdEstatusConsulta === EnumEstatusConsulta.Finalizado) {
            handleOpenAlert("Las consultas que ya han finalizado no se pueden reprogramar", "warning");
            return;
        }
        if (consultaSeleccionada.iIdEstatusConsulta === EnumEstatusConsulta.EnConsulta) {
            handleOpenAlert("El paciente ya se encuentra consultando", "warning");
            return;
        }
        fnFillFormConsulta(consultaSeleccionada);
        setModalOpenFormConsulta(true);
    };

    const handleClickCancelarConsulta = () => {
        if (consultaSeleccionada.iIdConsulta === 0) {
            handleOpenAlert("Seleccione una consulta de la tabla para continuar", "warning");
            return;
        }
        if (consultaSeleccionada.iIdEstatusConsulta === EnumEstatusConsulta.Cancelado) {
            handleOpenAlert("Seleccione una consulta que no haya sido cancelada", "warning");
            return;
        }
        if (consultaSeleccionada.iIdEstatusConsulta === EnumEstatusConsulta.Finalizado) {
            handleOpenAlert("Las consultas que ya han finalizado no se pueden cancelar", "warning");
            return;
        }
        if (consultaSeleccionada.iIdEstatusConsulta === EnumEstatusConsulta.EnConsulta) {
            handleOpenAlert("El paciente ya se encuentra consultando", "warning");
            return;
        }
        setModalOpenCancelarConsulta(true);
    };

    const handleClickRefrescarDatos = () => {
        const { txtFechaDe, txtFechaA } = formFiltroConsulta;
        const fechaProgramadaInicio = !txtFechaDe.value ? null : txtFechaDe.value.toISOString();
        const fechaProgramadaFin = !txtFechaA.value ? null : txtFechaA.value.toISOString();
        fnObtenerConsultas(fechaProgramadaInicio, fechaProgramadaFin);
    };

    const handleClickLimpiarFiltro = () => {
        const { txtFechaDe, txtFechaA } = getFormFiltroConsulta();

        fnObtenerConsultas();
        setFormFiltroConsulta({
            ...formFiltroConsulta,
            txtFechaDe: {
                ...txtFechaDe,
                value: null,
            },
            txtFechaA: {
                ...txtFechaA,
                value: null,
            },
        });
    };

    const handleClickLimpiarFolio = () => {
        setFolioValidado(false);
        setFolioUsuarioEncontrado(null);
        fnFillFormConsulta(getModelConsulta());
    };

    const handleClickValidarFolio = () => {
        const { txtFolioConsulta, txtTipoBusqueda } = formConsulta;
        const formValidado = {
            ...formConsulta,
            txtFolioConsulta: { ...txtFolioConsulta, error: txtFolioConsulta.value === "" },
        };

        setFormConsulta(formValidado);
        if (
            Object.values(formValidado)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        fnValidarFolio(txtFolioConsulta.value, txtTipoBusqueda.value);
    };

    const handleClickStartAdminConsulta = async () => {
        await fnObtenerColaborador();
    };

    const handleSubmitFormConsulta = (e) => {
        fnPrevent(e);

        const {
            txtFolioConsulta,
            txtNombrePaciente,
            txtTelefonoPaciente,
            txtCorreoPaciente,
            txtFechaProgramadaInicio,
            txtFechaProgramadaFin,
            chkFolio,
            slcIdioma,
            txtTipoBusqueda,
        } = formConsulta;

        const telefono = !txtTelefonoPaciente.value ? "" : txtTelefonoPaciente.value.replace(/ /g, "");
        const formValidado = {
            ...formConsulta,
            txtFolioConsulta: { ...txtFolioConsulta, error: chkFolio.value && txtFolioConsulta.value === "" },
            txtNombrePaciente: {
                ...txtNombrePaciente,
                error: consultaSeleccionada.iIdConsulta === 0 && txtNombrePaciente.value === "",
            },
            txtTelefonoPaciente: {
                ...txtTelefonoPaciente,
                error: consultaSeleccionada.iIdConsulta === 0 && telefono.length !== 10,
            },
            txtCorreoPaciente: {
                ...txtCorreoPaciente,
                error: consultaSeleccionada.iIdConsulta === 0 && !rxCorreo.test(txtCorreoPaciente.value),
            },
            txtFechaProgramadaInicio: { ...txtFechaProgramadaInicio, error: !txtFechaProgramadaInicio.value },
            txtFechaProgramadaFin: { ...txtFechaProgramadaFin, error: !txtFechaProgramadaFin.value },
        };

        //console.log(slcIdioma);

        setFormConsulta(formValidado);
        if (
            Object.values(formValidado)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        //Continuar aqui
        const entConsulta = {
            sFolio: folioUsuarioEncontrado ? folioUsuarioEncontrado.sFolio : "",
            iIdUsuario: folioUsuarioEncontrado ? folioUsuarioEncontrado.iIdUsuario : null,
            customerInfo: {
                name: txtNombrePaciente.value,
                phone: txtTelefonoPaciente.value,
                email: txtCorreoPaciente.value,
            },
            consulta: {
                iIdConsulta: consultaSeleccionada.iIdConsulta,
                iIdColaborador: usuarioColaborador.iIdColaborador,
                dtFechaProgramadaInicio: txtFechaProgramadaInicio.value.toLocaleString(),
                dtFechaProgramadaFin: txtFechaProgramadaFin.value.toLocaleString(),
            },
            sIdioma: slcIdioma.value,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            entFolio: folioUsuarioEncontrado ? folioUsuarioEncontrado : { sFolio: "" },
        };
        fnGuardarConsulta(entConsulta);
    };

    const handleSubmitCancelarConsulta = () => {
        const entConsulta = {
            consulta: {
                iIdConsulta: consultaSeleccionada.iIdConsulta,
                iIdColaborador: usuarioColaborador.iIdColaborador,
            },
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
        };
        fnCancelarConsulta(entConsulta);
    };

    const fnFillFormConsulta = (consulta) => {
        const {
            txtFolioConsulta,
            txtNombrePaciente,
            txtTelefonoPaciente,
            txtCorreoPaciente,
            txtFechaProgramadaInicio,
            txtFechaProgramadaFin,
            chkFolio,
        } = getFormConsulta();
        const { txtTipoBusqueda } = formConsulta;
        setFormConsulta({
            ...formConsulta,
            txtFolioConsulta: {
                ...txtFolioConsulta,
                value: !consulta.sFolio
                    ? txtTipoBusqueda.value === EnumTipoBusquedaFolio.usuario
                        ? consulta.sCorreoPaciente
                        : ""
                    : txtTipoBusqueda.value === EnumTipoBusquedaFolio.folio
                        ? consulta.sFolio
                        : consulta.sCorreoPaciente,
            },
            txtNombrePaciente: {
                ...txtNombrePaciente,
                value: !consulta.sNombrePaciente ? "" : consulta.sNombrePaciente,
            },
            txtTelefonoPaciente: {
                ...txtTelefonoPaciente,
                value: !consulta.sTelefonoPaciente ? "" : consulta.sTelefonoPaciente,
            },
            txtCorreoPaciente: {
                ...txtCorreoPaciente,
                value: !consulta.sCorreoPaciente ? "" : consulta.sCorreoPaciente,
            },
            txtFechaProgramadaInicio: {
                ...txtFechaProgramadaInicio,
                value: !consulta.dtFechaProgramadaInicio ? null : new Date(consulta.dtFechaProgramadaInicio),
            },
            txtFechaProgramadaFin: {
                ...txtFechaProgramadaFin,
                value: !consulta.dtFechaProgramadaFin ? null : new Date(consulta.dtFechaProgramadaFin),
            },
            chkFolio: { ...chkFolio, value: consulta.iIdConsulta !== 0 },
        });
    };

    const fnObtenerColaborador = async () => {
        const payload = {
            loader: "Consultando información del colaborador...",
            url: apiGetColaboradoresCallCenterEspecialistas + "?piIdUsuarioCGU=" + usuarioSesion.iIdUsuario,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            if (response.Result.length < 1) {
                handleOpenAlert("No se ha ingresado con una cuenta de colaborador.");
                setUsuarioColaborador(null);
                return;
            }
            const colaborador = response.Result[0];
            if (!colaborador.bAcceso) {
                handleOpenAlert("Aún no cuenta con acceso a las consultas de Meditoc Call Center.");
                setUsuarioColaborador(null);
                return;
            }
            setUsuarioColaborador(colaborador);
        } else {
            setUsuarioColaborador(null);
        }
    };

    const fnObtenerConsultas = async (fechaProgramadaInicio = "", fechaProgramadaFin = "") => {
        const payload = {
            loader: "Obteniendo consultas...",
            url:
                apiCallCenterGetConsultaDetalle +
                "?piIdColaborador=" +
                usuarioColaborador.iIdColaborador +
                "&pdtFechaProgramadaInicio=" +
                fechaProgramadaInicio +
                "&pdtFechaProgramadaFin=" +
                fechaProgramadaFin,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaConsultas(
                response.Result.map((consulta) => ({
                    ...consulta,
                    sFolio: !consulta.iIdUsuario ? consulta.sFolio : consulta.sCorreoPaciente,
                    sIconStatus:
                        consulta.iIdEstatusConsulta === EnumEstatusConsulta.CreadoProgramado ? (
                            <QueryBuilderIcon style={{ color: blue[500] }} />
                        ) : consulta.iIdEstatusConsulta === EnumEstatusConsulta.Reprogramado ? (
                            <UpdateIcon style={{ color: blue[500] }} />
                        ) : consulta.iIdEstatusConsulta === EnumEstatusConsulta.EnConsulta ? (
                            <TimerIcon style={{ color: yellow[500] }} />
                        ) : consulta.iIdEstatusConsulta === EnumEstatusConsulta.Finalizado ? (
                            <DoneIcon style={{ color: green[500] }} />
                        ) : consulta.iIdEstatusConsulta === EnumEstatusConsulta.Cancelado ? (
                            <BlockIcon style={{ color: red[500] }} />
                        ) : null,
                }))
            );
        }
    };

    const fnValidarFolio = async (psFolio, tipoBusqueda) => {
        const payload = {
            loader: "Validando folio...",
            url:
                apiCallCenterGetFolioUsuairo +
                "?piIdColaboradorRealizaBusqueda=" +
                usuarioColaborador.iIdColaborador +
                "&psFolio=" +
                psFolio +
                "&pbActivo=&pbBaja=" +
                "&piTipoBusqueda=" +
                tipoBusqueda,
            alert: true,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            if (response.Result) {
                setFolioValidado(true);
                setFolioUsuarioEncontrado(response.Result);
                fnFillFormConsulta(response.Result);
            } else {
                handleOpenAlert("No se encontró el folio solicitado");
            }
        }
    };

    const fnGuardarConsulta = async (entConsulta) => {
        const payload = {
            loader: "Guardando consulta...",
            url: apiCallCenterSaveFolioEspecialistaConsulta,
            body: entConsulta,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormConsulta(false);
            await fnObtenerConsultas();
            setConsultaSeleccionada(getModelConsulta());
        }
        fnPreventBlur();
    };

    const fnCancelarConsulta = async (entConsulta) => {
        const payload = {
            loader: "Cancelando consulta...",
            url: apiCallCenterCancelarFolioEspecialistaConsulta,
            body: entConsulta,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenCancelarConsulta(false);
            setConsultaSeleccionada(getModelConsulta());
            await fnObtenerConsultas();
        }
        fnPreventBlur();
    };

    return (
        <AdminConsultaContext.Provider
            value={{
                usuarioColaborador,
                listaConsultas,
                consultaSeleccionada,
                modalOpenFormConsulta,
                modalOpenCancelarConsulta,
                formConsulta,
                formFiltroConsulta,
                folioValidado,
                folioUsuarioEncontrado,
                handleOpenFormConsulta,
                handleOpenCancelarConsultar,
                handleChangeConsultaSeleccionada,
                handleChangeFolioValidado,
                handleChangeFormConsultaText,
                handleChangeFormConsultaDate,
                handleChangeFormConsultaDateInicio,
                handleChangeFormConsultaCheck,
                handleChangeFormFiltroConsultaDate,
                handleChangeFormFiltroConsultaDateDe,
                handleClickNuevaConsulta,
                handleClickEditarConsulta,
                handleClickCancelarConsulta,
                handleClickRefrescarDatos,
                handleClickLimpiarFiltro,
                handleClickLimpiarFolio,
                handleClickValidarFolio,
                handleClickStartAdminConsulta,
                handleSubmitFormConsulta,
                handleSubmitCancelarConsulta,
            }}
        >
            {props.children}
        </AdminConsultaContext.Provider>
    );
}

export function useAdminConsulta() {
    return useContext(AdminConsultaContext);
}
